import { matchPath } from 'react-router-dom';

import type { Optional } from 'chaika-common-types';

import { NavigationItemParams } from '@store/App/LeftMenu';

export function findActiveSubItem(subItems: NavigationItemParams[], pathname: string): Optional<NavigationItemParams> {
    return subItems
        .filter(subItem => matchPath({ path: subItem.link, end: false }, pathname))
        .sort((left, right) => right.link.length - left.link.length)[0];
}
